// extracted by mini-css-extract-plugin
module.exports = {"tip":"_1jIiu","tipTop":"_1HRg-","tipBottom":"_3Wgtz"};